// @flow

import React, {Fragment, type Node} from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import jquery from 'jquery';
import {SPPage, type PermsMap} from 'app/general/structures/SPPage';
import {showNotification} from 'app/toasts/slice';
import {reportUnexpectedState} from 'app/utils/errors';
import {sendSentryMessage} from 'app/utils/sentry';

type OwnProps = {|
  children?: (PermsMap) => Node,
|};

type DispatchProps = {|
  showNotification: typeof showNotification,
|};

type Props = {|
  ...OwnProps,
  ...DispatchProps,
|};

class BaseWrapStaticContentPage extends React.PureComponent<Props> {
  containerRef = React.createRef<HTMLDivElement>();

  content: any;
  originalContainer: any;

  componentDidMount() {
    this.content = jquery('#static-page-content');
    this.originalContainer = this.content.parent();

    this.content
      .appendTo(jquery(this.containerRef.current))
      .css('display', 'block');

    // `DOMContentLoaded` may fire before your script has a chance to run, so check before adding a listener
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.callInitPage());
    } else {
      // `DOMContentLoaded` already fired
      this.callInitPage();
    }
  }

  componentWillUnmount() {
    this.content.appendTo(this.originalContainer).css('display', 'none');
  }

  callInitPage() {
    const {showNotification} = this.props;

    if (window.initPageJS != null) {
      window.initPageJS(showNotification, this.showErrorAndSendToSentry);
    }
  }

  showErrorAndSendToSentry = (message: string, opts: any) => {
    opts = {sentryData: {}, ...opts};

    sendSentryMessage(opts.sentryData.message || message, {
      extra: opts.sentryData,
    });
    this.props.showNotification(message, 'error');
  };

  renderChildren(userRoles: PermsMap) {
    const {children} = this.props;
    const placeholder = document.getElementById(
      'static-page-children-placeholder'
    );

    if (children != null) {
      if (placeholder == null) {
        reportUnexpectedState('USEC13');
      } else {
        return ReactDOM.createPortal(children(userRoles), placeholder);
      }
    }
    return null;
  }

  render() {
    return (
      <SPPage horizontalPadding={false}>
        {(userRoles) => (
          <Fragment>
            <div ref={this.containerRef} />
            {this.renderChildren(userRoles)}
          </Fragment>
        )}
      </SPPage>
    );
  }
}

const mapDispatchToProps = {showNotification};

export const WrapStaticContentPage = connect<
  Props,
  OwnProps,
  _,
  DispatchProps,
  _,
  _
>(
  null,
  mapDispatchToProps
)(BaseWrapStaticContentPage);
